export const CHANGE_PAGE = 'app/CHANGE_PAGE';

export const changePage = payload => ({
  type: CHANGE_PAGE,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/change-page.js